<template>
  <el-dialog title="Внимание!" :visible.sync="attentionVisible" width="500px">
    <span>
        Оповещение будет опубликовано после проведения модерации.
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close-modal')">ОК</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["attention-visible"]
};
</script>
